import { useUniqueFieldSuffix } from '../contexts/unique-field-suffix-context';
export function getInputId(fieldId, uniqueId) {
    return `form-field-input-${fieldId}-${uniqueId}`;
}
export function getLabelId(fieldId, uniqueId) {
    return `form-field-label-${fieldId}-${uniqueId}`;
}
export function getPrefixId(fieldId, uniqueId) {
    return `form-field-prefix-${fieldId}-${uniqueId}`;
}
export function getDescriptionId(fieldId, uniqueId) {
    return `form-field-description-${fieldId}-${uniqueId}`;
}
export function getErrorId(fieldId, uniqueId) {
    return `form-field-error-${fieldId}-${uniqueId}`;
}
// eslint-disable-next-line max-params
export function getAriaDescribedBy(errorId, descriptionId, error, description) {
    return [
        error && errorId,
        description && descriptionId
    ].filter(Boolean).join(' ') || undefined;
}
export function getErrorDataHook(target) {
    return `field-error-${target}`;
}
export function useFieldAttributes(fieldId, error, description) {
    const uniqueId = useUniqueFieldSuffix();
    const errorId = getErrorId(fieldId, uniqueId);
    const descriptionId = getDescriptionId(fieldId, uniqueId);
    return {
        inputId: getInputId(fieldId, uniqueId),
        labelId: getLabelId(fieldId, uniqueId),
        prefixId: getPrefixId(fieldId, uniqueId),
        descriptionId,
        errorId,
        ariaDescribedBy: getAriaDescribedBy(errorId, descriptionId, error, description)
    };
}

//# sourceMappingURL=field-attributes.js.map